import "./Footer.css";
import logo from "../assets/pictures/logojasne.svg"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Dane firmy */}
        <div className="footer-section">
          <p><strong>Pracownia Piękne Wnętrza</strong></p>
          <p>SANDRA SIUDMIAK</p>
          <p>studio.piekne.wnetrza@gmail.com</p>
        </div>

        {/* Logo */}
        <div className="footer-section logo-section">
          <img src={logo} alt="Logo firmy" />
        </div>

        {/* Lokalizacja / hasło */}
        <div className="footer-section footer-location">
          <p>Architekt Bydgoszcz | Więcbork | Architekt wnętrz</p>
        </div>
      </div>

      {/* Dolna linia + copyright */}
      <div className="footer-bottom">
       
        <p>
  © Piękne Wnętrza 2025 | Created by{" "}
  <a
    href="https://www.instagram.com/qubit.soft/"
    target="_blank"
    rel="noopener noreferrer"
  >
    Qubity
  </a>
</p>
      </div>
    </footer>
  );
};

export default Footer;
